import { useNavigate } from "react-router-dom";
import {
    Eye,
    Pencil,
    Trash2,
} from "lucide-react";

import LoadingRoles from "./LoadingRoles";
import EmptyRoles from "./EmptyRoles";

function RoleTable({
    roles,
    loading,
    onDelete,
    reload,
}) {

    const navigate = useNavigate();

    const handleDelete = async (id) => {

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this role?"
        );

        if (!confirmDelete) return;

        try {

            await onDelete(id);

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to delete role.");

        }

    };

    if (loading) {

        return <LoadingRoles />;

    }

    if (!roles.length) {

        return <EmptyRoles />;

    }

    return (

        <div className="table-wrapper">

            <table className="admin-table">

                <thead>

                    <tr>

                        <th>Role Name</th>

                        <th>Description</th>

                        <th>Status</th>

                        <th>Created</th>

                        <th>Actions</th>

                    </tr>

                </thead>

                <tbody>

                    {roles.map((role) => (

                        <tr key={role._id}>

                            <td>

                                <strong>

                                    {role.roleName}

                                </strong>

                            </td>

                            <td>

                                {role.description || "-"}

                            </td>

                            <td>

                                <span
                                    className={`status-badge ${role.status.toLowerCase()}`}
                                >

                                    {role.status}

                                </span>

                            </td>

                            <td>

                                {new Date(
                                    role.createdAt
                                ).toLocaleDateString()}

                            </td>

                            <td>

                                <div className="table-actions">

                                    <button
                                        className="view-btn"
                                        title="View"
                                        onClick={() =>
                                            navigate(
                                                `/admin/roles/${role._id}`
                                            )
                                        }
                                    >

                                        <Eye size={18} />

                                    </button>

                                    <button
                                        className="edit-btn"
                                        title="Edit"
                                    >

                                        <Pencil size={18} />

                                    </button>

                                    <button
                                        className="delete-btn"
                                        title="Delete"
                                        onClick={() =>
                                            handleDelete(role._id)
                                        }
                                    >

                                        <Trash2 size={18} />

                                    </button>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}

export default RoleTable;